import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {ScrollTopComponent} from '@content/partials/layout/scroll-top/scroll-top.component';
import {NoticeComponent} from '@content/partials/content/general/notice/notice.component';
import {SpinnerDialogComponent} from '@core/_shared/spinner-dialog/spinner-dialog.component';
import {SpinnerButtonModule} from '@content/partials/content/general/spinner-button/spinner-button.module';
import {CoreModule} from '@core/core.module';

@NgModule({
    declarations: [
        ScrollTopComponent,
        NoticeComponent,
        SpinnerDialogComponent,
    ],
    exports: [
        ScrollTopComponent,
        NoticeComponent,
        SpinnerButtonModule,
        MatIconModule,
        SpinnerDialogComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        NgbModule,
        NgScrollbarModule,
        CoreModule,
        SpinnerButtonModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatDialogModule
    ]
})
export class PartialsModule {
}
